'use strict';

exports.IndexFiltersMode = void 0;
(function (IndexFiltersMode) {
  IndexFiltersMode["Default"] = "DEFAULT";
  IndexFiltersMode["Filtering"] = "FILTERING";
  IndexFiltersMode["EditingColumns"] = "EDITING_COLUMNS";
})(exports.IndexFiltersMode || (exports.IndexFiltersMode = {}));
